import { render } from "./SaveOrgUnit.vue?vue&type=template&id=7a56fe24&scoped=true"
import script from "./SaveOrgUnit.vue?vue&type=script&lang=js"
export * from "./SaveOrgUnit.vue?vue&type=script&lang=js"

import "./SaveOrgUnit.vue?vue&type=style&index=0&id=7a56fe24&scoped=true&lang=css"

import exportComponent from "C:\\Users\\52618\\Documentos\\TheGoodMark\\Sistemas\\RHTGM\\orangehrm-5.9\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a56fe24"]])

export default __exports__